/**
 * 多语言配置，与参考站 h5-ab.ng-demo.xyz 保持一致
 * 每种语言对应 src/locales/{code}.json
 */
export const LOCALE_STORAGE_KEY = "language";

export const localeList = [
  { code: "zh", label: "简体中文" },
  { code: "hk", label: "繁体中文" },
  { code: "en", label: "English" },
  { code: "th", label: "ไทย" },
  { code: "vn", label: "Việt Nam" },
  { code: "pg", label: "Português" },
  { code: "fp", label: "Filipino" },
  { code: "md", label: "မြန်မာ" },
];

export const defaultLocale = "zh";

export function getLocaleLabel(code, i18n) {
  const item = localeList.find((l) => l.code === code);
  if (item) return item.label;
  return i18n ? i18n.t("common.selectLanguage") : code;
}
